import CryptoJS from 'crypto-js';

function base64UrlFromBase64(b64: string): string {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function urlEncodedToJson(urlEncoded: string): string {
    const obj: Record<string, string> = {};
    new URLSearchParams(urlEncoded).forEach((value, key) => {
        obj[key] = value;
    });
    return JSON.stringify(obj);
}

function buildCanonical(
    method: string,
    path: string,
    queryInput: string,
    body: string,
): string {
    const bodyHash = CryptoJS.SHA256(body).toString(CryptoJS.enc.Hex);
    return `${method}\n${path}\n${queryInput}\n${bodyHash}`;
}

export function createRequestHash(
    key: string | CryptoJS.lib.WordArray,
    method: string,
    path: string,
    queryInput: string,
    body: string,
): string {
    const queryForCanonical = urlEncodedToJson(queryInput);
    const canonical = buildCanonical(method, path, queryForCanonical, body);
    // console.log('Canonical: ', canonical);

    const hmac = CryptoJS.HmacSHA256(canonical, key);
    const b64 = hmac.toString(CryptoJS.enc.Base64);
    return base64UrlFromBase64(b64);
}